import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  faPerson,
  faRoad,
  faSchool,
  faSign,
  faPenToSquare
} from '@fortawesome/free-solid-svg-icons';
import {
  StudentTicketListViewAsmResponseDTO
} from "../../../models/student-ticket/list-view/StudentTicketListViewAsmResponseDTO";
import {getTicketStatusColor} from "../../../models/student-ticket/TicketStatusASMColorMapping";
import {faCalendarPlus} from "@fortawesome/free-solid-svg-icons/faCalendarPlus";

@Component({
  selector: 'app-ticket-card-details',
  templateUrl: './ticket-card-details.component.html',
  styleUrls: ['./ticket-card-details.component.scss'],
  standalone: false,
})
export class TicketCardDetailsComponent {

  @Input() ticket: StudentTicketListViewAsmResponseDTO;

  @Output() addressDetailsAdjust = new EventEmitter<void>();
  @Output() schoolDetailsAdjust = new EventEmitter<void>();
  @Output() nameDetailsAdjust = new EventEmitter<void>();


  faPerson = faPerson;
  faSign = faSign;
  faSchool = faSchool;
  faRoad = faRoad;
  faPenToSquare = faPenToSquare;

  protected readonly faCalendarPlus = faCalendarPlus;
  protected readonly getTicketStatusColor = getTicketStatusColor;

  adjustAdressDetails() {
    this.addressDetailsAdjust.emit();
  }

  adjustSchoolDetails() {
    this.schoolDetailsAdjust.emit();
  }

  adjustNameDetails() {
    this.nameDetailsAdjust.emit();
  }

}
